import React from "react";

import { LineChart } from '@mui/x-charts/LineChart';
import Popper from "@mui/material/Popper";
import { styled } from "@mui/material/styles";

export default function Chart({ data }) {
  const ChartsTooltipRoot = styled(Popper, {
    name: "MuiChartsTooltip",
    slot: "Root",
    overridesResolver: (_, styles) => styles.root,
  })(({ theme }) => ({
    pointerEvents: "none",
    zIndex: theme.zIndex.modal,
  }));

  const CustomPopperRoot = (props) => {
    return (
      <ChartsTooltipRoot
        {...props}
        sx={{
          // color: "white",
          padding: "8px",
          borderRadius: "8px",
          "& .MuiChartsTooltip-root": {
            backgroundColor: "red",
            color: "red"
          },
          "& .MuiChartsTooltip-paper": {
            backgroundColor: "black", // Fundo da "tabela" do tooltip
            color: "red", // Cor do texto do tooltip
          },
          "& .MuiChartsTooltip-cell": {
            color: "white"
          },
          "& .MuiChartsTooltip-labelCell": {
            color: "white"
          },
          "& .MuiChartsTooltip-valueCell": {
            color: "white"
          },
          "& .MuiDefaultChartsAxisTooltipContent-root": {
            backgroundColor: "red", // Cor do fundo do tooltip
          },
          "& .MuiDefaultChartsAxisTooltipContent-valueCell": {
            color: "white", // Cor do valor dentro do tooltip
          },
          "& .MuiDefaultChartsAxisTooltipContent-labelCell": {
            color: "yellow", // Cor do rótulo dentro do tooltip
          }
        }}
        anchorEl={{
          getBoundingClientRect: () => ({
            ...props.anchorEl?.getBoundingClientRect(),
          }),
        }}
      />
    );
  };

  const FranceGDPperCapita = data?.map((item) => item.value) || [];

  const years = data?.map((item) => new Date(item.createdAt.slice(0, 4), item.createdAt.slice(5, 7), item.createdAt.slice(8, 10))) || [];

  const yearFormatter = (date) => {
    if (!(date instanceof Date) || isNaN(date)) return ""; // ou 'Invalid Date'
    return date
      .toLocaleString("pt-br", { month: "short" })
      .toUpperCase() + " " + date.getFullYear();
  };

  function formatNumber(num) {
    if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(1).replace('.0', '') + 'M';
    }

    if (num >= 1_000) {
      return (num / 1_000).toFixed(1).replace('.0', '') + 'K';
    }

    return num?.toString();
  }

  return (
    <div style={{ width: '100%', paddingLeft: 18 }}>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#FF00D6" />
            <stop offset="10%" stopColor="#CF07D5" />
            <stop offset="24%" stopColor="#9311D4" />
            <stop offset="42%" stopColor="#6419D3" />
            <stop offset="62%" stopColor="#431FD3" />
            <stop offset="84%" stopColor="#2E22D3" />
            <stop offset="100%" stopColor="#2724D3" />
          </linearGradient>
        </defs>
      </svg>
      <LineChart
        grid={{ vertical: false, horizontal: true }}
        xAxis={[
          {
            scaleType: "time",
            data: years,
            // tickMinStep: 1000 * 60 * 60 * 24 * 7,
            valueFormatter: yearFormatter,
            // tickLabelInterval: (value, index) => index % 1 === 0,
            disableLine: true,
            disableTicks: true,
            tickFontSize: 12,
            sx: {
              "& .MuiChartsAxis-tickLabel": {
                marginTop: '10px',  // Adiciona um espaçamento acima dos rótulos
              }
            }

          }
        ]}
        yAxis={[
          {
            disableLine: true,
            disableTicks: true,
            tickFontSize: 12,
            valueFormatter: (value) => formatNumber(value), // Converte 5000 → 5K
          }
        ]}
        series={[
          {
            data: FranceGDPperCapita,
            showMark: false,
            color: "url(#lineGradient)",
            type: "line",
          },

        ]}
        height={200}
        sx={{
          "& .css-6w4lf4-MuiLineElement-root": { strokeWidth: 4 }, '& .MuiChartsAxis-directionX': {
            transform: 'translate(0px, 160px)',
          }, '& .MuiChartsAxis-directionY': {
            transform: 'translate(60px, 0px)'
          }, '& .MuiLineElement-root': {
            transform: 'translate(0px, 3px)',
          }
        }}
      // slots={{ popper: CustomPopperRoot }}
      />
    </div>
  );
}
